import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import queryString from "app/services/queryStringService";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import {
  getBankLists,
  bankUpdates,
} from "app/services/MasterAdmin & ApiUSer/BankService";
import EditBanks from "./EditBanks";
import { AiOutlineEdit } from "react-icons/ai";

const BankList = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [editModelValues, setEditModelValues] = useState(null);

  const actionFormatter = (cell) => {
    return cell ? (
      <span className="text-success"> Active</span>
    ) : (
      <span className="text-danger"> Inactive</span>
    );
  };

  const editBankDetails = (row) => {
    setEditModelValues(row);
  };

  const editFormatter = (cell, row) => (
    <>
      <button
        type="button"
        className="btn btn-outline-primary"
        data-bs-toggle="modal"
        data-bs-target="#editBankModal"
        onClick={() => setEditModelValues(row)}
      >
        <AiOutlineEdit className="mr-1" />
        <span className=" mt-1"> Edit</span>
      </button>
    </>
  );

  const columns = [
    {
      dataField: "bankName",
      text: "Bank Name",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "shortCode",
      text: "Bank Short Code",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },

      //  formatter:companyFormatter,
    },

    {
      dataField: "address",
      text: "Address",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "accountNumber",
      text: "Account Number",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "ifscCode",
      text: "IFSC Code",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "swiftCode",
      text: "Swift Code",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "id",
      text: "Edit",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: editFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadBankLists = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    try {
      const response = await getBankLists(query);
      const responseData = response.data;
      setLoading(false);
      setData(responseData);
      setDataCount(responseData.length);
    } catch (error) {
      console.error(error);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  useEffect(() => {
    loadBankLists();
  }, [page, sizePerPage]);

  // ... rest of the component ...

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);

    setTimeout(async () => {
      await loadBankLists();
    }, 10);
  };

  const handleEditSubmit = async (data) => {
    try {
      const res = await bankUpdates(data.id, data);

      console.log(res);
      document.getElementsByClassName("btn-close")[0].click();
      await loadBankLists();
      if (res.status === "Success") {
        NotificationManager.success(res.message);
      } else {
        NotificationManager.error(res.message);
      }
    } catch (error) {
      NotificationManager.error(error);
      console.log(error);
    }
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === option.page.toString();
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer: sizePerPageRenderer,
  };

  return (
    <>
      {/* <div className="d-flex justify-content-between">
        <Breadcrumb routeSegments={[{ name: "Bank List" }]}></Breadcrumb>

        <Link
          className="btn btn-primary btn-md mb-2 "
          to="/master-admin/bank/add"
        >
          <i className="i-Add-User text-white mr-2"></i> Add Bank
        </Link>
      </div>

      <Helmet>
        <title>Bank List</title>
      </Helmet> */}

      <div>
        <Link
          className="btn btn-primary btn-md float-end"
          to="/master-admin/bank/add"
        >
          <i className="i-Add-User text-white mr-2"></i> Add Bank
        </Link>
      </div>
      <Helmet>
        <title>Bank List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Bank List" }]}></Breadcrumb>

      <div>
        <BootstrapTable
          hover
          //  remote
          keyField="id"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
      {editModelValues ? (
        <EditBanks
          editModelValues={editModelValues}
          handleEditSubmit={handleEditSubmit}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default BankList;
